document.addEventListener('DOMContentLoaded', () => {
    const previewText = /*html*/ `
    <span class="absolute -top-1.5 left-0 right-0 inline-flex items-center justify-center px-3 py-2 mx-auto text-sm text-center text-black rounded-sm max-w-96 bg-[#FBF13C]/90 hover:opacity-20 transition-opacity z-10">
        <span class="inline-flex items-center justify-center p-1 mr-2 text-sm bg-white rounded-full sm:mr-3 size-5">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="#000000" />
            </svg>
        </span>
        <strong class="mr-1">Förhandsgranskning</strong> - visas endast för admin &darr;
    </span>`

    const previewComponents = document.querySelectorAll('[data-preview]')
    if (previewComponents.length > 0) {
        previewComponents.forEach((component) => {
            component.insertAdjacentHTML('beforeend', previewText)
        })
    }
})
